import React from 'react';
import './ProgramSession.css';
import SessionRoster from './SessionRoster';

const ProgramSession = ({ session, onChange }) => {
  if (!session) return null

  return (
    <div className="session-container">
      <SessionRoster
        session={session}
        onChange={onChange}
      />
    </div>
  );
};

export default ProgramSession;
